import { FileState } from './file'
import { DependenciesState } from './dependencies'
import { UploadState } from './upload'
import { StateType } from 'typesafe-actions'
import { reducers } from '../configureStore'
import { Site, CHEGG, CITATION_MACHINE, BIBME, EASYBIB } from '../types'
import { UIState } from './ui'
import { AppState } from './app'
import { PusherState } from './pusher'

export interface StoreState {
  file: FileState
  dependencies: DependenciesState
  upload: UploadState
  site: Site
  ui: UIState
  app: AppState
  pusher: PusherState
}

export type RootState = StateType<typeof reducers>
export const PLACEHOLDER = 'placeholder'

export type SiteState = typeof EASYBIB | typeof CITATION_MACHINE | typeof BIBME | typeof PLACEHOLDER | typeof CHEGG
